var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogCatOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 150",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pet-outline-title"
  }, "Dog and cat sitting together") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pet-outline-title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4F6473",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 119c-3-25 4-48 21-61-7-15-2-32 12-38 13-6 29-1 35 11l18 4c6 1 7 9 2 13l-17 12c-4 3-9 4-14 3l-12-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 24c-14 2-23 15-19 29l17 10 8-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 59c11 9 25 10 36 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 61c-14 13-18 36-12 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 119c7-15 8-31 3-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 121c3-31 15-55 38-65l7-25 16 16 19-10 2 27c14 16 14 38 5 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 121c-3-17 0-32 9-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 121c15-2 25-11 28-25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 132c55-18 145-17 213 0",
    fill: "none",
    stroke: "#7A8F6B",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogCatOutline);
export default __webpack_public_path__ + "static/media/dog-cat-outline.3896cf1eb04c9f21f30a76b10e19de09.svg";
export { ForwardRef as ReactComponent };